import { GState } from "IZOX/STATIC";

class Funcs {

  static SetIndexScroll(num){
    GState.UPDATE("indexScroll", num);
  }

  static SetMenuClick(page){
    GState.UPDATE("menuClick", page);
  }

}

export default Funcs;